import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import { alpha, useTheme } from '@mui/material/styles'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'

import { useGlobalCopyStore } from '../../../common'

interface OnboardingBirthdayProps {
  selectedDate: number | null | undefined
  setSelectedDate: (value: number | null | undefined) => void
}

const OnboardingBirthday = ({ selectedDate, setSelectedDate }: OnboardingBirthdayProps) => {
  const { finstrong: copy } = useGlobalCopyStore()
  const theme = useTheme()

  const handleChange = (date: Date | null) => {
    setSelectedDate(Math.floor(new Date(date!).getTime() / 1000))
  }

  return (
    <Box sx={{ p: 24 }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          disableFuture={true}
          label={copy.onboarding_select_date}
          onChange={handleChange}
          slotProps={{
            nextIconButton: {
              sx: {
                color: 'primary.main',
                '&:hover': { bgcolor: alpha(theme.palette.primary.light, 0.1) },
              },
            },
            previousIconButton: {
              sx: {
                color: 'primary.main',
                '&:hover': { bgcolor: alpha(theme.palette.primary.light, 0.1) },
              },
            },
          }}
          sx={{
            width: '100%',
            '& .MuiIconButton-edgeEnd': {
              color: 'primary.main',
              '&:hover': { bgcolor: alpha(theme.palette.primary.light, 0.1) },
            },
          }}
          value={selectedDate ? new Date(selectedDate * 1000) : null}
        />
      </LocalizationProvider>
    </Box>
  )
}

export default observer(OnboardingBirthday)
